import React from "react";
import { CheckCircle2 } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function RequestAFreeQuote() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="request-a-free-quote" ref={ref} className={`relative flex flex-col lg:flex-row min-h-screen transition-opacity duration-700 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="w-full lg:w-1/2 bg-[hsl(222,47%,11%)] text-[hsl(0,0%,95%)] flex flex-col justify-center px-8 py-20 lg:p-24 relative overflow-hidden">
        <div className="relative z-10 max-w-xl mx-auto lg:mx-0">
          <h2 className="font-serif text-[hsl(45,30%,50%)] text-4xl md:text-5xl lg:text-[40px] leading-tight tracking-[-0.02em] mb-6">
            Start Your Transformation
          </h2>
          <p className="text-[hsl(0,0%,95%)]/70 text-lg leading-relaxed mb-8 font-sans font-light">
            Bring your vision to life with our expert craftsmanship. Whether it's
            a luxury wet room or a complete bathroom renovation, we deliver
            precision and elegance in every detail.
          </p>
          <div className="space-y-4">
            <div className="flex items-center gap-3 text-[hsl(0,0%,95%)]/90">
              <CheckCircle2 className="w-5 h-5 text-[hsl(45,30%,50%)]" />
              <span className="font-sans">Free detailed consultation</span>
            </div>
            <div className="flex items-center gap-3 text-[hsl(0,0%,95%)]/90">
              <CheckCircle2 className="w-5 h-5 text-[hsl(45,30%,50%)]" />
              <span className="font-sans">Transparent pricing, no hidden fees</span>
            </div>
            <div className="flex items-center gap-3 text-[hsl(0,0%,95%)]/90">
              <CheckCircle2 className="w-5 h-5 text-[hsl(45,30%,50%)]" />
              <span className="font-sans">Expert design advice included</span>
            </div>
          </div>
        </div>
        
        <div className="absolute top-0 right-0 w-64 h-64 bg-[hsl(45,30%,50%)] opacity-5 rounded-full blur-3xl transform translate-x-1/2 -translate-y-1/2 pointer-events-none" />
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-[hsl(222,47%,20%)] opacity-20 rounded-full blur-3xl transform -translate-x-1/2 translate-y-1/2 pointer-events-none" />
      </div>

      <div className="w-full lg:w-1/2 bg-[hsl(222,47%,15%)] flex flex-col justify-center px-6 py-20 lg:p-24">
        <div className="max-w-lg mx-auto w-full">
          <div className="mb-10">
            <h3 className="text-2xl font-serif text-[hsl(0,0%,95%)] mb-2">
              Request a Free Quote
            </h3>
            <p className="text-[hsl(0,0%,95%)]/60 font-sans text-sm">
              Fill out the details below and we'll get back to you within 24 hours.
            </p>
          </div>

          [wpforms id="697"]
        </div>
      </div>
    </section>;
}